import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { flenjorNameLogo } from '../../assets';

function NavigationBar(): ReactElement {
  return (
    <nav className="container nav" aria-label="Main navigation">
      <div className="centered_content nav_content">
        <div className="nav_centreLogo">
          <div>
            <Link className="link logo" to="/" aria-label="Flenjor home">
              <img className="nav_logo" src={flenjorNameLogo} alt="Flenjor" />
            </Link>
          </div>
        </div>
        <div className="nav_centreButtons">
          <span className="nav_slogan">#TheSoftLife</span>
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
